import { Button } from 'primereact/button';
import type { TooltipRenderProps } from 'react-joyride';

export const TourTooltip = ({
  continuous,
  index,
  step,
  size,
  backProps,
  primaryProps,
  skipProps,
  tooltipProps,
  isLastStep,
}: TooltipRenderProps) => {
  return (
    <div
      {...tooltipProps}
      className="max-w-sm rounded-lg border border-gray-200 bg-white p-4 shadow-xl"
    >
      {step.title && (
        <div className="mb-2 text-base font-semibold text-gray-900">
          {step.title}
        </div>
      )}

      <div className="mb-4 text-sm text-gray-600">{step.content}</div>

      <div className="flex items-center justify-between">
        <span className="text-xs text-gray-400">
          {index + 1} of {size}
        </span>

        <div className="flex gap-2">
          {!isLastStep && (
            <Button
              label="Skip"
              aria-label={skipProps['aria-label']}
              onClick={skipProps.onClick}
              data-action={skipProps['data-action']}
              role={skipProps.role}
              severity="secondary"
              text
              size="small"
            />
          )}
          {index > 0 && (
            <Button
              label="Back"
              aria-label={backProps['aria-label']}
              onClick={backProps.onClick}
              data-action={backProps['data-action']}
              role={backProps.role}
              severity="secondary"
              outlined
              size="small"
            />
          )}
          {continuous && (
            <Button
              label={isLastStep ? 'Done' : 'Next'}
              aria-label={primaryProps['aria-label']}
              onClick={primaryProps.onClick}
              data-action={primaryProps['data-action']}
              role={primaryProps.role}
              severity="primary"
              size="small"
            />
          )}
        </div>
      </div>
    </div>
  );
};
